import { useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../axiosInstances/axiosPrivate';
import { AcademiaResponse, WeekDay } from '../../types/common';
import { returnQueryConfig } from '../../utils/commonFunctions';

const useWeekDaysActions = () => {
  // query function to fetch all the week days from database declared here
  const getWeekDaysHandler = useQuery({
    queryKey: ['week-days'],
    queryFn: async (): Promise<AcademiaResponse<Array<WeekDay>>> => {
      const response = await getPrivateAxiosInstance('appointment').get(
        '/days/of/week/choices/'
      );

      return response.data;
    },

    ...returnQueryConfig(true),
  });

  return { getWeekDaysHandler };
};

export default useWeekDaysActions;
